import React, { useEffect, useRef, useState } from "react";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Link, useLocation } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import { usePermissions } from "../../common/PermissionContext";
import Swal from "sweetalert2";

const MetricScale = () => {

    const [metricScaleList, setMetricScaleList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [metricScaleId, setMetricScaleId] = useState("");
    const [number, setNumber] = useState("");
    const [sleepQuality, setSleepQuality] = useState("");
    const [muscleSoreness, setMuscleSoreness] = useState("");
    const [fatigueLevel, setFatigueLevel] = useState("");
    const [jointStiffness, setJointStiffness] = useState("");
    const [mentalReadiness, setMentalReadiness] = useState("");
    const [urineQuality, setUrineQuality] = useState("");
    const [restingHeartRate, setRestingHeartRate] = useState("");
    const [hunger, setHunger] = useState("");
    const [status, setStatus] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchMetricScale() {
            setIsLoading(true);
            const metricResponse = await func.getMertricScale();
            setMetricScaleList(Array.isArray(metricResponse) ? metricResponse : [])
            setIsLoading(false);
        }
        fetchMetricScale();
    }, [])

    const filteredData = metricScaleList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    async function newMetricScale() {
        setOpenModal(true);
        setNumber("");
    }

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const numberRender = (rowData) => {
        return <span>{rowData.number}</span>;
    };

    const sleepQualityRender = (rowData) => {
        return <span>{rowData.sleepQuality}</span>;
    };

    const muscleSorenessRender = (rowData) => {
        return <span>{rowData.muscleSoreness}</span>;
    };

    const fatigueLevelRender = (rowData) => {
        return <span>{rowData.fatigueLevel}</span>;
    };

    const jointStiffnessRender = (rowData) => {
        return <span>{rowData.jointStiffness}</span>;
    };

    const mentalReadinessRender = (rowData) => {
        return <span>{rowData.mentalReadiness}</span>;
    };

    const urineQualityRender = (rowData) => {
        return <span>{rowData.urineQuality}</span>;
    };

    const restingHeartRateRender = (rowData) => {
        return <span>{rowData.restingHeartRate}</span>;
    };

    const hungerRender = (rowData) => {
        return <span>{rowData.hunger}</span>;
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editMetricScale(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const msId = rowData.athleteMetricScaleId;
        return (
            <Link to="#" onClick={() => deleteMetricScale(msId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function editMetricScale(rowData) {
        const msId = rowData.athleteMetricScaleId;
        const msResponse = await func.getMertricScale(msId);
        setMetricScaleId(msResponse.athleteMetricScaleId);
        setNumber(msResponse.number)
        setSleepQuality(msResponse.sleepQuality);
        setMuscleSoreness(msResponse.muscleSoreness);
        setFatigueLevel(msResponse.fatigueLevel);
        setJointStiffness(msResponse.jointStiffness);
        setMentalReadiness(msResponse.mentalReadiness);
        setUrineQuality(msResponse.urineQuality);
        setRestingHeartRate(msResponse.restingHeartRate);
        setHunger(msResponse.hunger);
        setStatus(msResponse.status)
        setIsEdit(true)
        setOpenModal(true)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateMetricScale();
            } else {
                const formData = new FormData();
                formData.append("number", number);
                formData.append("sleepQuality", sleepQuality);
                formData.append("muscleSoreness", muscleSoreness);
                formData.append("fatigueLevel", fatigueLevel);
                formData.append("jointStiffness", jointStiffness);
                formData.append("mentalReadiness", mentalReadiness);
                formData.append("urineQuality", urineQuality);
                formData.append("restingHeartRate", restingHeartRate);
                formData.append("hunger", hunger);

                const createMetricscale = api.MetricScale;
                fetch(createMetricscale, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    function updateMetricScale() {
        const formData = new FormData();
        formData.append("number", number);
        formData.append("sleepQuality", sleepQuality);
        formData.append("muscleSoreness", muscleSoreness);
        formData.append("fatigueLevel", fatigueLevel);
        formData.append("jointStiffness", jointStiffness);
        formData.append("mentalReadiness", mentalReadiness);
        formData.append("urineQuality", urineQuality);
        formData.append("restingHeartRate", restingHeartRate);
        formData.append("hunger", hunger);

        const updateAns = api.MetricScale + '/' + metricScaleId;
        fetch(updateAns, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteMetricScale(ansId: string) {
        const deleteMs = api.MetricScale + '/' + ansId + '/' + 0;
        fetch(deleteMs, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Metric Scale</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newMetricScale() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Metric Scale">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="number"
                                                header="Number"
                                                body={numberRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="sleepQuality"
                                                header="Sleep Quality"
                                                body={sleepQualityRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="muscleSoreness"
                                                header="Muscle Soreness"
                                                body={muscleSorenessRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="fatigueLevel"
                                                header="FatigueLevel"
                                                body={fatigueLevelRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="jointStiffness"
                                                header="Joint Stiffness"
                                                body={jointStiffnessRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="mentalReadiness"
                                                header="Mental Readiness"
                                                body={mentalReadinessRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="urineQuality"
                                                header="UrineQuality"
                                                body={urineQualityRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="restingHeartRate"
                                                header="Resting Heart Rate"
                                                body={restingHeartRateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="hunger"
                                                header="Hunger"
                                                body={hungerRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                centered
                size="lg"
                show={openModal}
            >
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Metric Scale</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Number</label>
                                    <input
                                        type="number"
                                        min={-5}
                                        max={5}
                                        className="form-control"
                                        id="number"
                                        placeholder="Enter Number"
                                        required
                                        value={number}
                                        onChange={(e) => setNumber(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Sleep Quality</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        placeholder="Enter Sleep Quality"
                                        required
                                        value={sleepQuality}
                                        onChange={(e) => setSleepQuality(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Muscle Soreness</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        placeholder="Enter Muscle Soreness"
                                        required
                                        value={muscleSoreness}
                                        onChange={(e) => setMuscleSoreness(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Fatigue Level</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        placeholder="Enter Fatigue Level"
                                        required
                                        value={fatigueLevel}
                                        onChange={(e) => setFatigueLevel(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Joint Stiffness</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        placeholder="Enter Joint Stiffness"
                                        required
                                        value={jointStiffness}
                                        onChange={(e) => setJointStiffness(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Mental Readiness</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        placeholder="Enter Mental Readiness"
                                        required
                                        value={mentalReadiness}
                                        onChange={(e) => setMentalReadiness(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Urine Quality</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        placeholder="Enter Urine Quality"
                                        required
                                        value={urineQuality}
                                        onChange={(e) => setUrineQuality(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Resting Heart Rate</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        placeholder="Enter Resting Heart Rate"
                                        required
                                        value={restingHeartRate}
                                        onChange={(e) => setRestingHeartRate(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Hunger</label>
                                    <input
                                        type="text."
                                        className="form-control"
                                        id="name"
                                        placeholder="Enter Hunger"
                                        required
                                        value={hunger}
                                        onChange={(e) => setHunger(e.target.value)}
                                    />
                                </div>
                            </div>
                            {isEdit ?
                                <>
                                    <div className="row">
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <label className="form-label">Status</label>
                                        </div>
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    checked={status === '1'}
                                                    id="answerStatus"
                                                    onChange={(e) => {
                                                        setStatus(e.target.checked ? '1' : '0')
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </> : null
                            }
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default MetricScale;